import React, { useState } from "react";
import { Button } from "./ui/button";
import { Phone, Calculator, Car, ShoppingCart } from "lucide-react";
import OnlineOrderModal from "./OnlineOrderModal";

const CompactHero = () => {
  const [showOrderModal, setShowOrderModal] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
    <section 
      id="home" 
      className="parallax-bg bg-gradient-to-r from-gray-900 to-gray-800 text-white py-24 min-h-[600px] md:min-h-[700px]"
      style={{
        backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.5)), url("https://images.unsplash.com/photo-1657201512832-eb4986526c16?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=70&fm=webp")'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo & Brand */}
          <div className="mb-6 -mt-8">
            <h1 className="text-5xl lg:text-6xl font-bold text-yellow-400">
              Taxi Türlihof
            </h1>
            <p className="text-gray-300 text-xl">seit 2010</p>
          </div>
          
          {/* Main Message */}
          <div className="max-w-4xl mx-auto mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6 leading-tight">
              Ihr zuverlässiger Taxi-Service in der Zentralschweiz
            </h2>
            
            <p className="text-2xl text-gray-300 mb-12">
              Schnell, sicher und professionell – Zuverlässiger Service für Sie
            </p>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center mb-16">
            <Button 
              onClick={() => scrollToSection("calculator-cta")}
              className="bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-5 text-lg font-semibold rounded-xl shadow-lg"
              size="lg"
              data-testid="hero-price-calc-btn"
            >
              <Calculator className="w-5 h-5 mr-2" />
              Preis berechnen
            </Button>

            <Button 
              onClick={() => setShowOrderModal(true)}
              className="bg-yellow-600 hover:bg-yellow-700 text-white px-8 py-5 text-lg font-semibold rounded-xl shadow-lg border-2 border-yellow-500"
              size="lg"
              data-testid="hero-online-order-btn"
            >
              <ShoppingCart className="w-5 h-5 mr-2" />
              Per WhatsApp bestellen
            </Button>
            
            <Button 
              onClick={() => scrollToSection("calculator-cta")}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-5 text-lg font-semibold rounded-xl"
              size="lg"
              data-testid="hero-book-btn"
            >
              <Car className="w-5 h-5 mr-2" />
              Jetzt buchen
            </Button>
          </div>
        </div>
      </div>
    </section>
    <OnlineOrderModal isOpen={showOrderModal} onClose={() => setShowOrderModal(false)} />
    </>
  );
};

export default CompactHero;